import React from 'react';
import {PromocodeType} from '../types';
import {CopyOutlined} from '@ant-design/icons';
import {message, Tag, Tooltip} from 'antd';

type Props = {
  isLast: boolean;
  item: any;
};

export const PromocodeItem: React.FC<Props> = ({item, isLast}) => {
  const discountText = item.is_percentage
    ? `${item.discount_value.toLocaleString()}% تخفیف`
    : `${item.discount_value.toLocaleString()} تومان تخفیف`;

  const maxDiscountText = item.has_max_discount
    ? ` (حداکثر ${item.max_discount_amount.toLocaleString()} تومان)`
    : '';

  const status = item.used
    ? {text: 'استفاده‌شده', color: 'red'}
    : item.can_use
    ? {text: 'قابل استفاده', color: 'green'}
    : {text: 'غیرفعال', color: 'red'};

  const formattedDate = new Date(item.valid_until).toLocaleDateString('fa-IR');

  const handleCopy = () => {
    if (item.used) {
      message.warning('این کد قبلاً استفاده شده است');
    } else {
      navigator.clipboard.writeText(item.code);
      message.success(`کد تخفیف ${item.code} کپی شد`);
    }
  };

  return (
    <div
      className={`flex items-start justify-between p-4 border-b ${
        isLast ? '' : 'mb-4'
      } cursor-pointer hover:bg-gray-50 transition`}
      onClick={handleCopy}
    >
      <div className="flex-1 overflow-hidden">
        <h4 className="text-primary text-base font-semibold truncate">{item.code}</h4>

        <p className="text-sm text-gray-800 font-medium mt-1">
          {discountText}
          {maxDiscountText}
        </p>

        <p className="text-xs text-gray-500 mt-1">معتبر تا {formattedDate}</p>

        <Tag color={status.color} className="mt-2">{status.text}</Tag>
      </div>

      <div className="pl-4 pt-1">
        <Tooltip title="کپی کد">
          <CopyOutlined className="text-lg text-gray-500 hover:text-primary" />
        </Tooltip>
      </div>
    </div>
  );
};
